import { render } from "./MainContent.vue?vue&type=template&id=48541faa&scoped=true&ts=true"
import script from "./MainContent.vue?vue&type=script&lang=ts"
export * from "./MainContent.vue?vue&type=script&lang=ts"

import "./MainContent.vue?vue&type=style&index=0&id=48541faa&lang=less&scoped=true"

import exportComponent from "C:\\Users\\adavi\\Documents\\CosmicDS\\minids\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48541faa"]])

export default __exports__